import type { PortfolioFilterState } from "web_myplann/Shared/State/portfolioFilterAtom";

export const isPortfolioListNarrowed = (filter: PortfolioFilterState) =>
	filter.categories.length > 0;
